<template>
    <div class="account">
        <!-- 流向商品列表（待修复） -->
        <vFlowProductComponent :postList="postList" v-if="flag"></vFlowProductComponent>
    </div>
</template>
<script>
import vFlowProductComponent from '../../listComponent/basicdata/flowSourceLists/flowProductListComponent.vue';
export default {
    name: 'flowProductList',
    components: {
        vFlowProductComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                source_file: true,
                batchSaveBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>